import { Fahrrad } from '@gsm/entities';
import { DynamicFormControlLayout, DynamicFormValueControlModel, DynamicFormValueControlModelConfig, serializable } from '@ng-dynamic-forms/core';

export const TYPE_FAHRRAD_LISTE = 'FAHRRAD-LISTE';

export interface FahrradListeAdditional extends Record<string, any> {
  displayFahrradVersperrt?: boolean;
}

export interface FahrradListeModelConfig extends DynamicFormValueControlModelConfig<Fahrrad[]> {
  additional?: FahrradListeAdditional;
}

export class FahrradListeModel extends DynamicFormValueControlModel<Fahrrad[]> {
  @serializable() readonly type: string = TYPE_FAHRRAD_LISTE;

  constructor(config: FahrradListeModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);
    // `additional` is set from super()
  }
}

export enum FahrradNachweisVorhanden {
  Vorhanden = 'VORHANDEN',
  Nachgebracht = 'NACHGEBRACHT',
  NichtVorhanden = 'NICHT_VORHANDEN',
}
